import { Pagination } from '$core/models/pagination';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { Observable } from 'rxjs';
import {
  AddBatchRecipientResponse,
  AutocompletedAddress,
  BatchRecipient,
  BatchRecipientRequestBody,
  RemoveAddressOrInvoicesBody,
} from '../models/batch-recipient';

@Injectable({
  providedIn: 'root',
})
export class RecipientService {
  protected apiRoute = '/batch-mailing/recipient';
  protected apiVersion = '/v1';

  constructor(private readonly _http: HttpClient) {}

  public getRecipients(params: Params): Observable<Pagination<BatchRecipient>> {
    return this._http.get<Pagination<BatchRecipient>>(
      `${this.apiVersion}${this.apiRoute}`,
      { params: params }
    );
  }

  public createRecipient(
    params: BatchRecipientRequestBody
  ): Observable<AddBatchRecipientResponse> {
    return this._http.post<AddBatchRecipientResponse>(
      `${this.apiVersion}${this.apiRoute}`,
      params
    );
  }

  public updateRecipient(
    id: number,
    params: BatchRecipientRequestBody
  ): Observable<BatchRecipient> {
    return this._http.post<BatchRecipient>(
      `${this.apiVersion}${this.apiRoute}/${id}`,
      params
    );
  }

  public removeRecipientAddress(
    body: RemoveAddressOrInvoicesBody
  ): Observable<Pagination<BatchRecipient>> {
    return this._http.post<Pagination<BatchRecipient>>(
      `${this.apiVersion}/batch-mailing/recipients-delete`,
      body
    );
  }

  public getOps(params?: Params): Observable<AutocompletedAddress[]> {
    return this._http.get<AutocompletedAddress[]>(`/v1/ops/autocomplete`, {
      params,
    });
  }
}
